export const MAP_ACTIVITIES_CAMEL_CASE = new Map([
  ['measurements', 'Measurements'],
  ['medications', 'Medications'],
  ['checkIns', 'Check-ins']
])

export const MAP_ACTIVITIES_TO_CODES = new Map([
  ['measurements', 2],
  ['medications', 3],
  ['checkIns', 1]
])

export const DASHBOARDS_LIST = ['/', '/dashboard/performance-dashboard']
